module.exports = __webpack_public_path__ + "img/rare-1-xl.2f757a6.webp";